import { translateObject, translateObjectInverse } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../config';
import { cursorPaginatedResponseMap, cardMap } from '../translationMaps';
import getCursorPaginationParams from '../utils/getCursorPaginationParams';
import withAxios from '../utils/with-axios';
var DEFAULT_PER_PAGE = 20;
function formatCard(data) {
  var card = data.data;
  var translated = translateObject(cardMap, card);
  return translated;
}
function formatAllResponse(data) {
  var translatedPagination = translateObject(cursorPaginatedResponseMap, data);
  if (translatedPagination.data.length) {
    translatedPagination.data = translatedPagination.data.map(function (item) {
      return formatCard({
        data: item
      });
    });
  }
  return translatedPagination;
}

/**
 * List cards
 *
 * @param {Object} $axios [$axios=axios] Axios instance.
 * @param {Object[]} options
 * @param {Number} [options[].usePagination=true] Whether to use pagination
 * @param {Number} [options[].limit=DEFAULT_PER_PAGE]
 *     How many items to  display per page
 * @param {String} [options[].next] Cursor to paginate forwards from
 * @param {String} [options[].previous] Cursor to paginate backwards from
 * @returns {Promise} Unresolved Promise from the API.
 */
function list($axios) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultParams = {
    use_pagination: true,
    limit: DEFAULT_PER_PAGE
  };
  var params = getCursorPaginationParams(options, defaultParams);
  return $axios.get(urls.apiV2('/cards'), {
    params: params
  }).then(prop('data')).then(formatAllResponse);
}

/**
 * Updates a card
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Card ID to update
 * @param {Object} data Data object to update the card
 * @returns {Promise} Unresolved Promise from the API.
 */
function update($axios, id, data) {
  var formatted = translateObjectInverse(cardMap, data);
  return $axios.put(urls.apiV2("/cards/".concat(id)), formatted);
}

/**
 * Removes a card
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String} id Card ID to remove
 * @returns {Promise} Unresolved Promise from the API.
 */
function remove($axios, id) {
  return $axios.delete(urls.apiV2("/cards/".concat(id)));
}
export default {
  remove: withAxios(remove),
  list: withAxios(list),
  update: withAxios(update)
};